export default __webpack_public_path__ + "static/media/statusConfirmed.fdbfc6d9.png";